export default "__VITE_ASSET__Zzi1Uvtbp2$IAZepOrT$9A__"